import MyTabs from '../../components/MyTabs';
import Genres from './Genres';

const GeneralGenres = () => {

    const tabs = [
        { id: "Basic", title: "Basic Genre Info", Component: Genres },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default GeneralGenres;